import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';
import FormControl from '@material-ui/core/FormControl';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import { useTranslation } from 'react-i18next';

// icon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey } from '@fortawesome/free-solid-svg-icons';
import MapIcon from '@material-ui/icons/Map';
import PersonIcon from '@material-ui/icons/Person';
import HomeIcon from '@material-ui/icons/Home';
import EmailIcon from '@material-ui/icons/Email';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import InputIcon from '@material-ui/icons/Input';

import ResetPwd from '../resetPwd';

import { StyledButton } from '../../../components/button/Button';

import { globalStyle } from '../../../global/style';
import './styles.css';

// auth
import AuthService from '../../../services/auth.service';

// context
import UserContext from '../../../context/UserContext';

const useStyles = makeStyles(globalStyle);

export default function User() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [isResetPass, setIsResetPass] = React.useState(false);
  const [isProfile, setIsProfile] = React.useState(true);

  const currentUser = AuthService.getCurrentUser();
  const { setLogout, userProfile } = useContext(UserContext);

  const onLogout = () => {
    setLogout({ isLogout: true });
  };

  if (!AuthService.isLogin()) {
    return false;
  }

  return (
    <div className={classes.root}>
      <Grid container direction="column" spacing={2}>
        {isResetPass && (
          <>
            <NavigateBeforeIcon
              style={{ marginBottom: 10 }}
              onClick={() => {
                setIsProfile(true);
                setIsResetPass(false);
              }}
            />
            <ResetPwd />
          </>
        )}
        {isProfile && (
          <>
            <Grid item xs>
              <List component="nav" aria-label="main mailbox folders">
                <ListItem>
                  <ListItemIcon>
                    <PersonIcon fontSize="small" style={{ color: '#000' }} />
                  </ListItemIcon>
                  <ListItemText primary={(
                    <Typography variant="body2">
                      {currentUser.profile.firstname}
                      {' '}
                      {currentUser.profile.lastname}
                    </Typography>
                  )}
                  />
                </ListItem>
                <Divider />
                <ListItem>
                  <ListItemIcon>
                    <HomeIcon fontSize="small" style={{ color: '#000' }} />
                  </ListItemIcon>
                  <ListItemText primary={<Typography variant="body2">{currentUser.profile.agency_name}</Typography>} />
                </ListItem>
                <Divider />
                <ListItem>
                  <ListItemIcon>
                    <EmailIcon fontSize="small" style={{ color: '#000' }} />
                  </ListItemIcon>
                  <ListItemText primary={<Typography variant="body2">{currentUser.profile.email}</Typography>} />
                </ListItem>
                <Divider />
                <Box mt={2} display="flex" alignItems="center">
                  <Box>
                    <Button
                      startIcon={<FontAwesomeIcon icon={faKey} style={{ color: '#000', fontSize: 12 }} />}
                      onClick={() => {
                        setIsResetPass(!isResetPass);
                        setIsProfile(false);
                      }}
                      id="change-password"
                    >
                      <Typography style={{ fontsize: 15, fontFamily: 'Kanit' }} noWrap>{t('เปลี่ยนรหัสผ่าน')}</Typography>
                    </Button>
                  </Box>
                  <Box borderLeft={1} style={{ borderColor: '#ccc' }}>
                    <Button
                      startIcon={<InputIcon style={{ color: '#000', fontSize: 14 }} />}
                      href={`${process.env.REACT_APP_BACKOFFICE_API_URL}`}
                      target="_blank"
                      title={t('เข้าระบบหลังบ้าน')}
                    >
                      <Typography style={{ fontsize: 15, fontFamily: 'Kanit' }} noWrap>{t('เข้าระบบหลังบ้าน')}</Typography>
                    </Button>
                  </Box>
                </Box>
              </List>
            </Grid>
            {/* ปิดใช้ download จากตาราง detail ของแต่ละข้อมูล */}
            {/* <Grid item xs>
              <Box display="flex">
                <Box><GetAppIcon color="disabled" /></Box>
                <Box><Typography variant="h6" style={{ fontSize: 16, color: '#555' }}>&nbsp;  ดาวน์โหลด</Typography></Box>
              </Box>
              <Divider />
              <Box mt={4}>
                <Button variant="contained" color="primary" className={classes.margin} fullWidth>
                  <Box display="flex" alignItems="center">
                    <Box p={1} mt={2}><ThailandIcon style={{ fontSize: '3.5em' }} /></Box>
                    <Box>
                      <Typography align="left" variant="subtitle1">ดาวน์โหลด</Typography>
                      <Typography align="left" variant="body2" style={{ fontWeight: 600 }}>สถานการณ์น้ำขณะนี้ ( .CSV )</Typography>
                    </Box>
                  </Box>
                </Button>
              </Box>
            </Grid> */}
            { (userProfile.user_type.id === 1 || userProfile.user_type.id === 2) && (
            <Grid item xs>
              <Box display="flex" mt={4}>
                <Box><MapIcon color="disabled" /></Box>
                <Box><Typography variant="h6" style={{ fontSize: 16, color: '#555' }}>&nbsp;  {t('รายงานสถานการณ์')}</Typography></Box>
              </Box>
              <Divider />
              <Box m={3} pt={0} p={2}>
                <ul className="b">
                  <li>
                    <Link href={`${process.env.REACT_APP_BACKOFFICE_API_URL}/backoffice/news`} target="_blank" title={t('ระบบรายงานสถานการณ์แจ้งเหตุการณ์และขอความช่วยเหลือ')}><Typography variant="body2">  {t('ระบบรายงานสถานการณ์แจ้งเหตุการณ์และขอความช่วยเหลือ')}</Typography></Link>
                  </li>
                </ul>
              </Box>
              <Box display="flex" mt={4}>
                <Box><MapIcon color="disabled" /></Box>
                <Box><Typography variant="h6" style={{ fontSize: 16, color: '#555' }}>&nbsp;  {t('ข้อมูลคาดการณ์จากแบบจำลอง')}</Typography></Box>
              </Box>
              <Divider />
              <Box m={3} pt={0} p={2}>
                <ul className="b">
                  <li>
                    <Link href={`${process.env.REACT_APP_THAIWATER_URL}/FlashFlood`} target="_blank" title={t('ระบบเตือนภัยน้ำท่วมฉับพลันด้วยค่าดัชนีศักยภาพการเกิดน้ำท่วมฉับพลัน')}><Typography variant="body2">  {t('ระบบเตือนภัยน้ำท่วมฉับพลันด้วยค่าดัชนีศักยภาพการเกิดน้ำท่วมฉับพลัน')}</Typography></Link>
                  </li>
                  <li>
                    <Link href={`${process.env.REACT_APP_THAIWATER_URL}/situation/district`} target="_blank" title={t('ระบบวิเคราะห์ปริมาณฝนสูงสุดรายอำเภอ')}><Typography variant="body2">  {t('ระบบวิเคราะห์ปริมาณฝนสูงสุดรายอำเภอ')}</Typography></Link>
                  </li>
                  <li>
                    <Link href={`${process.env.REACT_APP_THAIWATER_URL}/forecast/wrfroms`} target="_blank" title={t('ระบบประเมินปริมาณน้ำฝนและพยากรณ์ฝนล่วงหน้า')}><Typography variant="body2">  {t('ระบบประเมินปริมาณน้ำฝนและพยากรณ์ฝนล่วงหน้า')}</Typography></Link>
                  </li>
                  <li>
                    <Link href={`${process.env.REACT_APP_THAIWATER_URL}/forecast/rainfall_month`} target="_blank" title={t('ระบบแสดงแผนที่ฝนคาดการณ์รายเดือน')}><Typography variant="body2">  {t('ระบบแสดงแผนที่ฝนคาดการณ์รายเดือน')}</Typography></Link>
                  </li>
                  <li>
                    <Link href={`${process.env.REACT_APP_THAIWATER_URL}/drought/monitoring`} target="_blank" title={t('ระบบติดตามภัยแล้ง')}><Typography variant="body2">  {t('ระบบติดตามภัยแล้ง')}</Typography></Link>
                  </li>
                  <li>
                    <Link href={`${process.env.REACT_APP_THAIWATER_URL}/salinity/onwr`} target="_blank" title={t('ระบบคาดการณ์ความเค็มรุกตัวในแม่น้ำเจ้าพระยาตอนล่าง')}><Typography variant="body2">  {t('ระบบคาดการณ์ความเค็มรุกตัวในแม่น้ำเจ้าพระยาตอนล่าง')}</Typography></Link>
                  </li>
                  <li>
                    <Link href={`${process.env.REACT_APP_THAIWATER_URL}/floodforecast/onwr`} target="_blank" title={t('ระบบคาดการณ์น้ำท่า')}><Typography variant="body2">  {t('ระบบคาดการณ์น้ำท่า')}</Typography></Link>
                  </li>
                </ul>
              </Box>
              <Box display="flex" mt={4}>
                <Box><MapIcon color="disabled" /></Box>
                <Box><Typography variant="h6" style={{ fontSize: 16, color: '#555' }}>&nbsp;  {t('ระบบแผนที่ข้อมูลทรัพยากรน้ำ')}</Typography></Box>
              </Box>
              <Divider />
              <Box m={3} pt={0} p={2}>
                <ul className="b">
                  <li>
                    <Link href="https://supermap.onwr.go.th/" target="_blank" title={t('ระบบแผนที่ข้อมูลทรัพยากรน้ำ (Supermap)')}><Typography variant="body2">  {t('ระบบแผนที่ข้อมูลทรัพยากรน้ำ (Supermap)')}</Typography></Link>
                  </li>
                </ul>
              </Box>
            </Grid>
            )}
            <Grid item align="center">
              <FormControl id="logout-button" style={{ width: '70%', marginTop: 30 }}>
                <StyledButton onClick={onLogout}>{t('ออกจากระบบ')}</StyledButton>
              </FormControl>
            </Grid>
          </>
        )}
      </Grid>
    </div>
  );
}
